import LegalPageLayout from "@/components/LegalPageLayout";
import { COMPANY } from "@/lib/site";

export default function Terms() {
  return (
    <LegalPageLayout
      meta={{
        title: "Terms & Conditions — Adviserz | Quant Core Technologies Private Limited",
        description:
          "Terms & Conditions governing use of the Adviserz website and platform, operated by Quant Core Technologies Private Limited. The platform does not provide SEBI-regulated investment advisory or research analyst services.",
        canonical: "https://adviserz.in/terms",
      }}
      overline="Legal"
      title="Terms & Conditions"
      intro={`These Terms & Conditions govern your access to and use of the website and services operated under the brand name Adviserz by ${COMPANY.legalName} ("the Company", "we", "us"). By accessing or using this website you agree to these Terms. If you do not agree, please do not use the website.`}
      sections={[
        {
          h: "Nature of the platform",
          p: [
            `Adviserz is a brand name of ${COMPANY.legalName}. Adviserz is not a separate legal entity and is not a regulated intermediary.`,
            "The platform is a financial technology, quantitative analytics and market intelligence platform. It provides technology, data analytics, research infrastructure, market data visualisation and educational content.",
          ],
        },
        {
          h: "No SEBI-regulated services",
          p: [
            "The Company is currently not registered with the Securities and Exchange Board of India as a Research Analyst or as an Investment Adviser. The website does not currently provide SEBI-regulated investment advisory or research analyst services.",
            "No content on the website constitutes investment advice, a research report, a recommendation or a solicitation to transact in securities. No service on the website is offered for sale as an investment recommendation, trading signal or advisory package, and no payment is collected for any such service.",
          ],
        },
        {
          h: "Technology services only",
          p: [
            "Any services made available are technology and information services. The Company does not execute trades, hold client funds or securities, manage portfolios, or act as a broker, distributor or custodian.",
          ],
        },
        {
          h: "Informational and analytical nature of content",
          p: [
            "All data, analytics, models, screens, visualisations, summaries and written content are provided for informational, educational and analytical purposes only, and are general in nature.",
            "Content is not tailored to the investment objectives, risk tolerance, financial circumstances or needs of any individual user.",
          ],
        },
        {
          h: "No guarantee of returns",
          p: [
            "The Company makes no representation or warranty regarding profitability, returns, accuracy rates or any particular outcome. Claims of guaranteed, fixed, assured or risk-free returns are not made and should not be inferred.",
          ],
        },
        {
          h: "Market risk",
          p: [
            "Investments in securities and financial instruments, including derivatives, are subject to market risk, including possible loss of principal. Derivatives involve leverage and may not be suitable for all persons. Past performance does not guarantee future results.",
          ],
        },
        {
          h: "User responsibility",
          p: [
            "You are solely responsible for evaluating the merits and risks of any decision you take. You should conduct independent research and consult a SEBI-registered financial professional before making any investment decision.",
            "You agree not to treat any output of the platform as a recommendation, and acknowledge that any use you make of the platform is at your own risk.",
          ],
        },
        {
          h: "AI limitations",
          p: [
            "The platform uses artificial intelligence, machine learning and automated data-processing systems. AI-generated and algorithmically generated outputs may contain errors, omissions, delays, biases or inaccuracies, and may be incomplete or out of date.",
            "Where back-tested, simulated or historical model results are displayed, such results do not guarantee future results.",
          ],
        },
        {
          h: "Data accuracy limitations",
          p: [
            "While reasonable efforts are made to maintain data quality, the Company does not warrant that any data or analytic is accurate, complete, current or uninterrupted, and shall not be liable for errors, omissions or delays in data.",
          ],
        },
        {
          h: "Third-party data and services",
          p: [
            "The platform may incorporate data, content or services obtained from third parties, including exchanges, data vendors, news providers and cloud service providers. Such third-party material remains subject to the terms and limitations of the respective provider, and the Company makes no warranty in respect of it.",
          ],
        },
        {
          h: "Intellectual property",
          p: [
            `All content, software, design, trademarks, branding, models and documentation on this website are owned by or licensed to ${COMPANY.legalName} and are protected by applicable intellectual property laws.`,
            "You may not copy, reproduce, republish, scrape, reverse engineer, resell or create derivative works from any part of the platform without prior written consent.",
          ],
        },
        {
          h: "Acceptable use",
          list: [
            "Do not use the platform for any unlawful, fraudulent or manipulative purpose",
            "Do not misrepresent platform content as investment advice or as a regulated research report",
            "Do not redistribute, resell or commercially exploit platform content without written consent",
            "Do not attempt to gain unauthorised access to systems, accounts or data",
            "Do not interfere with platform operation, security or availability",
            "Do not use automated means to extract data except where expressly permitted",
          ],
        },
        {
          h: "Limitation of liability",
          p: [
            `To the maximum extent permitted by law, ${COMPANY.legalName}, its directors, officers, employees and affiliates shall not be liable for any indirect, incidental, special, consequential, punitive or exemplary loss, or for any trading or investment loss, loss of profits, loss of data or loss of goodwill, arising from your use of, or inability to use, the website or its content.`,
          ],
        },
        {
          h: "No reliance on outputs",
          p: [
            "You acknowledge that no fiduciary, advisory or professional relationship is created by your use of the website, and that the Company assumes no duty to you in respect of any decision you take based on platform content.",
          ],
        },
        {
          h: "External links",
          p: [
            "The website may link to third-party websites. Such links are provided for convenience only and do not constitute endorsement. The Company is not responsible for the content, accuracy or practices of external sites.",
          ],
        },
        {
          h: "Changes to services",
          p: [
            "The Company may modify, suspend or discontinue any part of the website or platform, including features, data or content, at any time and without notice. These Terms may also be updated from time to time, and continued use constitutes acceptance of the revised Terms.",
          ],
        },
        {
          h: "Governing law and jurisdiction",
          p: [
            "These Terms are governed by the laws of India. Subject to applicable law, the courts at Mohali, Punjab, India shall have jurisdiction in respect of any dispute arising out of or in connection with these Terms or your use of the website.",
          ],
        },
        {
          h: "Contact",
          p: [
            `For questions relating to these Terms, write to ${COMPANY.email}. Postal address: ${COMPANY.address}.`,
          ],
        },
      ]}
    />
  );
}
